<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="活动名称" prop="name">
                <a-input v-model="queryParam.name" placeholder="请输入活动名称" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="活动状态" prop="status">
                <a-select v-model="queryParam.status" placeholder="请选择活动状态" allow-clear>
                  <a-select-option :value="0">预热</a-select-option>
                  <a-select-option :value="1">进行中</a-select-option>
                  <a-select-option :value="2">已结束</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="上架状态" prop="putawayStatus">
                <a-select v-model="queryParam.putawayStatus" placeholder="请选择上架状态" allow-clear>
                  <a-select-option :value="false">未上架</a-select-option>
                  <a-select-option :value="true">已上架</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24" style="float: right">
              <span class="table-page-search-submitButtons" :style="{ float: 'right', overflow: 'hidden' }">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" @click="$refs.createRebateActivity.handleAdd()" v-hasPermi="['played:rebate/activity:add']">
          <a-icon type="plus" />新增
        </a-button>
        <a-button type="primary" @click="$refs.createSouvenirActivity.handleAdd()" v-hasPermi="['played:rebate/activity:add']">
          <a-icon type="plus" />新增伴手礼活动
        </a-button>
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['played:rebate/activity:remove']">
          <a-icon type="delete" />删除
        </a-button>
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <CreateRebateActivity
        ref="createRebateActivity"
        @ok="getList"
      />
      <CreateSouvenirActivity
        ref="createSouvenirActivity"
        @ok="getList"
      />
      <RebateActivityTask
        ref="rebateActivityTask"
        @ok="getList"
      />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <template slot="putawayStatus" slot-scope="text, record">
          <a-tag v-if="!record.putawayStatus" color="red">未上架</a-tag>
          <a-tag v-if="record.putawayStatus" color="green">已上架</a-tag>
        </template>
        <template slot="status" slot-scope="text, record">
          <a-tag v-if="record.status === 0" color="orange">预热</a-tag>
          <a-tag v-if="record.status === 1" color="green">进行中</a-tag>
          <a-tag v-if="record.status === 2" color="red">已结束</a-tag>
        </template>
        <div slot="mainImage" slot-scope="text, record">
          <img :src="record.mainImage" style="width:100px; cursor: pointer;" preview alt=""/>
        </div>
        <span slot="startTime" slot-scope="text, record">
          {{ parseTime(record.startTime) }}
        </span>
        <span slot="endTime" slot-scope="text, record">
          {{ parseTime(record.endTime) }}
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.claimStartTime) }}
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.claimEndTime) }}
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <a v-show="record.type === 1" @click="$refs.createRebateActivity.handleUpdate(record, undefined)" v-hasPermi="['played:rebate/activity:edit']">
            <a-icon type="edit" />修改
          </a>
          <a v-show="record.type === 2" @click="$refs.createSouvenirActivity.handleUpdate(record, undefined)" v-hasPermi="['played:rebate/activity:edit']">
            <a-icon type="edit" />修改
          </a>
          <a-divider type="vertical" v-hasPermi="['played:rebate/activity:remove']" />
          <a @click="handleDelete(record)" v-hasPermi="['played:rebate/activity:remove']">
            <a-icon type="delete" />删除
          </a>
          <br v-hasPermi="['played:rebate/task:index']" />
          <a @click="$refs.rebateActivityTask.handleRebateTask(record)" v-hasPermi="['played:rebate/task:index']">
            <a-icon type="setting" /> 返现任务管理
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        :show-quick-jumper="false"
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { listScript } from '@/api/played/script'
import { tableMixin } from '@/store/table-mixin'
import CreateRebateActivity from './modules/CreateRebateActivity'
import RebateActivityTask from './modules/RebateActivityTask'
import CreateSouvenirActivity from './modules/CreateSouvenirActivity'
import Dept from '@/views/system/dept/index.vue'
import { delRebateActivity, listRebateActivity } from '@/api/played/rebateActivity'

export default {
  name: 'RebateActivity',
  components: {
    Dept, CreateRebateActivity, RebateActivityTask, CreateSouvenirActivity
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      playedScriptList: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        name: undefined,
        status: undefined,
        putawayStatus: undefined,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: '活动名称',
          dataIndex: 'name',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '活动文案',
          dataIndex: 'copyText',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '活动主图URL',
          dataIndex: 'mainImage',
          scopedSlots: { customRender: 'mainImage' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '活动开始时间',
          dataIndex: 'startTime',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '活动结束时间',
          dataIndex: 'endTime',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '领取开始时间',
          dataIndex: 'claimStartTime',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '领取结束时间',
          dataIndex: 'claimEndTime',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '总奖池金额',
          dataIndex: 'totalPool',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '剩余奖池金额',
          dataIndex: 'remainingPool',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '活动状态',
          dataIndex: 'status',
          scopedSlots: {customRender: 'status'},
          ellipsis: true,
          align: 'center'
        },
        {
          title: '上架状态',
          dataIndex: 'putawayStatus',
          scopedSlots: {customRender: 'putawayStatus'},
          ellipsis: true,
          align: 'center'
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: '10%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.getList()
    listScript({ scriptName: this.queryParam.scriptName }).then(res => {
      this.playedScriptList = res.data
    })
  },
  computed: {
  },
  watch: {
  },
  methods: {
    /** 查询银河打本剧本宣传物料列表 */
    getList () {
      this.loading = true
      listRebateActivity(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        name: undefined,
        status: undefined,
        putawayStatus: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中编号为' + ids + '的数据',
        onOk () {
          return delRebateActivity(ids)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                '删除成功',
                3
              )
            })
        },
        onCancel () {}
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk () {
          that.download('played/script/material/export', {
            ...that.queryParam
          }, `script/material_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    }
  }
}
</script>
